export const NODE_LABELS = {
  process: "New Process",
  actor: "New Actor",
  decision: "New Decision",
  external: "New External",
  hub: "New Hub",
}

export function miniMapNodeColor(node) {
  switch (node.type) {
    case "actor":
      return "#FFEB3B"
    case "process":
      return "#93c5fd"
    case "decision":
      return "#5eead4"
    case "hub":
      return "#333"
    case "external":
      return "#FFCC80"
    case "group":
      return "rgba(180, 180, 200, 0.5)"
    default:
      return "#93c5fd"
  }
}
